import { get, writable } from 'svelte/store';

import { debounce } from 'src/helpers/utilities';
import { normalizeEmail } from 'src/helpers/email_helpers';
import { set_devices_data_android } from 'src/services/lists_update_android';
import { set_devices_data_ios } from 'src/services/lists_update_ios';
import type { Device } from 'src/types/Device';

import { app, os } from 'src/stores/session/native-bridge';
import { user_data, user_settings } from '../account/user';

function create_devices() {
	const { subscribe, set, update } = writable<{ [key: string]: Device }>(
		JSON.parse(localStorage.getItem('devices')) || {},
	);

	return {
		subscribe,
		set,
		update: (new_device: Device) =>
			update((devices) => {
				return { ...devices, [new_device.id]: new_device };
			}),
		massUpdate: (new_devices: { [key: string]: Device }) => {
			update((devices: any) => {
				return { ...devices, ...new_devices };
			});
		},
		remove: (id: string) =>
			update((devices) => {
				delete devices[id];
				return devices;
			}),
		reset: () => set({}),
	};
}

export const devices = create_devices();

devices.subscribe((val: { [key: string]: Device }) => {
	localStorage.setItem('devices', JSON.stringify(val));

	if (get(app) && get(user_data).email) {
		debounce(() => {
			const _user_data = get(user_data);
			const _user_data_to_pass = {
				password: _user_data.password,
				username: normalizeEmail(_user_data.email),
				user_url: _user_data.user_api_url,
				user_id: _user_data.user_id,
				lang: get(user_settings).lang,
			};

			if (_user_data.password !== '') {
				if (get(os) !== 'IOS') {
					set_devices_data_android(_user_data_to_pass, val);
				} else {
					set_devices_data_ios(_user_data_to_pass, val);
				}
			}
		}, 3000);
	}
});
